import angular from 'angular';

module.exports = angular.module('common.services.segment', [])
.service('Segment', class {
  identify(id) {
    if (!window.segment) {
      this.logUndefined();
      return;
    }

    window.segment.identify(id);
  }

  track(eventName, eventProperties = {}) {
    if (!window.segment) {
      this.logUndefined();
      return;
    }

    const formattedEventProperties = {
      screen: {
        height: window.screen.height,
        width: window.screen.width,
      },
      ...eventProperties,
    };

    if (window.segmentChannel) {
      formattedEventProperties.channel = window.segmentChannel;
    }

    window.segment.track(eventName, formattedEventProperties);
  }

  // If you pass one argument, it's assumed to be the page name.
  // If you pass two, the first is the category and the second is the name.
  page(categoryOrName, name) {
    if (!window.segment) {
      this.logUndefined();
      return;
    }

    window.segment.page(categoryOrName, name);
  }

  logUndefined() {
    console.warn('Segment is not defined!!!');
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/segment.js
 **/